<template>
  <v-container fluid dark fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-form>
          <v-card class="elevation-12">
            <v-toolbar dark>
              <v-toolbar-title>Login</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-text-field
                prepend-icon="mdi-account"
                name="username"
                label="Login"
                type="text"
                :loading="loading"
                v-model="form.username">
              </v-text-field>
              <v-text-field
                prepend-icon="mdi-lock"
                name="password"
                label="Password"
                type="password"
                :loading="loading"
                v-model="form.password">
              </v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" type="submit" @click.prevent="login" :loading="loading">Login</v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import authService from '@/services/auth'

export default {
  data () {
    return {
      loading: false,
      form: {
        username: '',
        password: ''
      }
    }
  },

  methods: {
    async login () {
      this.loading = true

      try {
        const { data } = await authService.login(this.form)
        this.$store.commit('LOGIN', data.data.token)
        this.$store.commit('NAME', data.data.display_name)
        this.$router.replace('/')
      } catch (err) {}

      this.loading = false
    }
  },

  created () {
    if (this.$store.state.token) {
      this.$router.replace('/')
    }
  }
}
</script>
